var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.data,"items-per-page":5,"item-key":"corretora","sort-by":"corretora"},scopedSlots:_vm._u([{key:"item.corretora",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s((item.corretora) ? item.corretora: '-')+" ")]}},{key:"item.receivedVal",fn:function(ref){
var item = ref.item;
return [_vm._v(" ("+_vm._s(item.receivedQtd)+") "+_vm._s(item.receivedVal)+" ")]}},{key:"item.defaultingsVal",fn:function(ref){
var item = ref.item;
return [_vm._v(" ("+_vm._s(item.defaultingsQtd)+") "+_vm._s(item.defaultingsVal)+" ")]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }